import { render } from "./payment-confirmation.vue?vue&type=template&id=3adb79b2&ts=true"
import script from "./payment-confirmation.vue?vue&type=script&lang=ts"
export * from "./payment-confirmation.vue?vue&type=script&lang=ts"

import "./payment-confirmation.vue?vue&type=style&index=0&id=3adb79b2&lang=css"

import exportComponent from "C:\\Projects\\OnlinePayments\\OnlinePayments\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__